import React from "react";
import * as RadixProgress from "@radix-ui/react-progress";
import styles from "./progressBar.module.scss";

export interface ProgressBarProps {
  /** A number between 0 and 100 (inclusive) signifying the loading progress. Should be managed by a parent class so a new value can be passed as it updates. */
  progressValue: number;
  /** The size variant of the progress bar. "large" is default, and "small" is a thinner version. */
  size?: "small" | "large";
  /** Additional classname to set styles for the outer container of the progress bar, such as the width or border color. */
  progressBarClassName?: string;
  /** Additional classname to set styles for the indicator of the progress bar, such as the background color as the bar fills. */
  indicatorClassName?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progressValue,
  size = "large",
  progressBarClassName = "",
  indicatorClassName = "",
}) => {
  return (
    <RadixProgress.Root
      className={`${styles.progressBar} ${progressBarClassName}`}
      value={progressValue}
    >
      <RadixProgress.Indicator
        className={`${styles.progressBarIndicator} ${
          size === "small" ? styles.progressBarSmall : styles.progressBarLarge
        } ${indicatorClassName}`}
        /* inline style is necessary to slide the progress bar indicator across the page */
        style={{ transform: `translateX(-${100 - progressValue}%)` }}
        data-testid="progressBarIndicator"
      />
    </RadixProgress.Root>
  );
};
